import { queryOptions } from '@tanstack/react-query';
import APIClient from '../../../api/APIClient';
import { List } from '../../list/types/List';

export interface GetUserListsResponse extends Omit<List, 'OwnerID'> {
    tags: number[];
}

export async function getUserLists(userID: number, order?: 'ID' | 'Name') {
    const res = await APIClient.get<GetUserListsResponse[]>(`/user/${userID}/lists`, { params: { sort: order } });
    return res.data;
}

export function getUserListsOptions(userID: number) {
    return queryOptions({
        queryKey: ['user', userID, 'lists'],
        queryFn: () => getUserLists(userID),
    });
}
